export default {
    methods: {
        persistCoverageAreas(business) {
            return new Promise((resolve) => {
                if (!this.locations.length) {
                    resolve();
                } else {
                    const url = `${this.$config.endpoints.organisation}/${business.slug}/coveragearea`;
                    const requests = [];
                    this.locations.forEach((location) => {
                        requests.push(this.$axios.$post(url, {
                            id: location.id,
                            name: location.name,
                            lat: location.lat,
                            lon: location.lon,
                            radius: location.radius,
                        }));
                    });
                    Promise.all(requests).then(() => {
                        resolve();
                    });
                }
            });
        },
    },
};
